import constants from './constants';

export function receiveToken(token) {
  return {
    type: constants.actions.RECEIVE_TOKEN,
    token,
  };
}

export default {
  receiveToken,
};
